// src/app/orders/ordersSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orders: null,     // single object instead of array
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload;     // store the whole object
    },
    clearOrders: (state) => {
      state.orders = null;               // reset when needed
    },
  },
});

export const { setOrders, clearOrders } = ordersSlice.actions;
export default ordersSlice.reducer;
